module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/475.8b067f46.png";